/* VB · Contra reembolso = app Releasit COD Form (decisión §8.2, parcela R). Sin modal propio: abre el formulario
   de Releasit con SUS mecanismos y lo deja vestir a assets/vb-cod.css.
   - [data-vb-cod="cart"]   (carrito lateral): lleva las líneas de /cart.js al carrito propio de Releasit y abre su
     formulario, igual que hace la app con su botón de carrito (refreshCartFromCartJs) → window._rsiV2.
   - [data-vb-cod="product"] (aviso de la ficha): pulsa el botón de compra de Releasit (oculto por CSS) y marca la
     oferta por cantidad que coincide con el pack elegido en la ficha.
   Nunca envía nada: el pedido solo se crea si la clienta pulsa «Confirmar pedido» dentro del formulario. */
(() => {
  if (window.__vbCod) return;
  window.__vbCod = true;
  const root = document.documentElement;
  if (window._RSI_COD_FORM_SETTINGS) root.classList.add('vb-cod-on');

  const ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const waitFor = async (fn, ms = 8000) => {
    const t0 = Date.now();
    for (;;) {
      const v = fn();
      if (v) return v;
      if (Date.now() - t0 > ms) throw new Error('vb-cod: Releasit no responde');
      await sleep(120);
    }
  };
  const dialog = () => document.querySelector('dialog#rsi_form_wrapper, dialog._rsi_main_form_dialog_element');
  const isOpen = () => { const d = dialog(); return !!(d && d.open); };

  function busy(btn, on) {
    btn.classList.toggle('is-loading', on);
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }

  // Devuelve el foco al botón que abrió el formulario cuando Releasit lo cierra (X, Esc o fondo).
  function restoreFocusOnClose(btn) {
    waitFor(() => !isOpen() && 'closed', 600000).then(() => { if (btn.isConnected) btn.focus({ preventScroll: true }); }).catch(() => {});
  }

  async function openFromCart(btn) {
    const v = await waitFor(() => window._rsiV2 && window._rsiV2.cartService && window._rsiV2.getState && window._rsiV2);
    const cs = v.cartService;
    const cid = await waitFor(() => { const s = v.getState(); return s.cartInfo && s.cartInfo.id; });
    const cart = await (await fetch(`${ROOT_URL}cart.js`, { headers: { Accept: 'application/json' } })).json();
    if (!cart.item_count) return false;
    const lines = cart.items.map((it) => {
      const line = { merchandiseId: `gid://shopify/ProductVariant/${it.variant_id}`, quantity: it.quantity || 1 };
      const props = it.properties || {};
      const keys = Object.keys(props).filter((k) => props[k] !== null && props[k] !== '');
      if (keys.length) line.attributes = keys.map((k) => ({ key: k, value: String(props[k]) }));
      return line;
    });
    await v.setState({ isCartButtonLoading: true });
    await cs.clearCart(cid);
    const res = await cs.addProduct(cid, lines);
    const c = (res && res.cartLinesAdd && res.cartLinesAdd.cart) || (res && res.cart);
    if (!c || !c.lines) { await v.setState({ isCartButtonLoading: false }); throw new Error('vb-cod: no se pudo preparar el carrito'); }
    const first = c.lines.edges[0] && c.lines.edges[0].node;
    const num = (gid) => (gid ? Number(String(gid).split('/').pop()) : undefined);
    await v.setState({
      cartInfo: c,
      products: c.lines.edges.map((e) => e.node.merchandise),
      currentVariantId: first ? num(first.merchandise.id) : undefined,
      currentProductId: first ? num(first.merchandise.product && first.merchandise.product.id) : undefined,
      triggerCartUpdate: 0,
      isOpen: true,
      isCartButtonLoading: false,
      isClearingCart: false,
    });
    return true;
  }

  async function openFromProduct(btn) {
    const b = await waitFor(() => document.querySelector('#rsi_buy_now_button'));
    b.click();
    await waitFor(isOpen, 6000);
    // Pack elegido en la ficha (cantidad) → oferta por cantidad equivalente de Releasit.
    const form = document.querySelector('form[data-vb-product-form]');
    const qty = form ? parseInt((form.querySelector('[data-qty-input]') || {}).value, 10) || 1 : 1;
    const pid = String(btn.dataset.productId || (window.productData && window.productData.id) || '');
    const sets = window._RSI_COD_FORM_QUANTIY_OFFERS || [];
    const set = sets.find((o) => o && o.isActive && Array.isArray(o.pIds) && o.pIds.includes(pid));
    if (!set || !Array.isArray(set.offers)) return true;
    const idx = set.offers.findIndex((o) => Number(o.qty) === qty);
    if (idx < 0) return true;
    const label = await waitFor(() => dialog() && dialog().querySelector(`label[for="quantity_offer_${idx}"]`), 3000).catch(() => null);
    const input = label && dialog().querySelector(`#quantity_offer_${idx}`);
    if (label && input && !input.checked) label.click();
    return true;
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-vb-cod]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    if (!window._RSI_COD_FORM_SETTINGS) return;
    busy(btn, true);
    try {
      const ok = btn.dataset.vbCod === 'product' ? await openFromProduct(btn) : await openFromCart(btn);
      if (ok) {
        // Foco dentro del formulario (Releasit lo deja en <body>) para teclado y lector de pantalla.
        const f = await waitFor(() => isOpen() && dialog().querySelector('form'), 3000).catch(() => null);
        if (f && !f.contains(document.activeElement)) { f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); }
        watchDialog();
        restoreFocusOnClose(btn);
      }
    } catch (err) {
      console.warn(err);
      // Releasit no respondió (app bloqueada, API cambiada o COD no disponible aquí): se retira lo COD para no dejar un botón muerto.
      if (!isOpen()) root.classList.remove('vb-cod-on');
    } finally {
      busy(btn, false);
    }
  });

  // Emojis en los botones del formulario (textos del panel de Releasit, compartidos con el LIVE): se quitan solo en este
  // tema (Nicolas 28-oct). Releasit repinta el formulario al cambiar de oferta → observer acotado al diálogo mientras está abierto.
  const EMOJI = /[\p{Extended_Pictographic}\u{1F1E6}-\u{1F1FF}\uFE0F\u200D]/gu;
  const clean = (root) => root.querySelectorAll('.rsi-custom-button span, .rsi-custom-button p').forEach((el) => {
    el.childNodes.forEach((n) => {
      if (n.nodeType !== 3 || !EMOJI.test(n.nodeValue)) return;
      EMOJI.lastIndex = 0;
      n.nodeValue = n.nodeValue.replace(EMOJI, '').replace(/\s{2,}/g, ' ').replace(/^\s*·\s*|\s*·\s*$/g, '').trim();
    });
    EMOJI.lastIndex = 0;
  });
  let mo = null;
  const watchDialog = () => {
    const d = dialog();
    if (!d || d.__vbClean) return;
    d.__vbClean = true;
    clean(d);
    mo = new MutationObserver(() => { mo.disconnect(); clean(d); mo.observe(d, { childList: true, subtree: true, characterData: true }); });
    mo.observe(d, { childList: true, subtree: true, characterData: true });
  };
  new MutationObserver(() => { if (dialog()) watchDialog(); }).observe(document.body, { childList: true });
  if (dialog()) watchDialog();

  // Esc con el formulario abierto: Releasit no lo atiende (tampoco en el LIVE) → se pulsa SU botón de cerrar,
  // y el evento no llega al tema para que no se cierre también el carrito de debajo.
  window.addEventListener('keydown', (e) => {
    if (!isOpen()) return;
    // Tab dentro del formulario: que no llegue al trap de foco del carrito (component-cart.js), que lo anula.
    if (e.key === 'Tab') { e.stopImmediatePropagation(); return; }
    if (e.key !== 'Escape') return;
    e.stopImmediatePropagation();
    e.preventDefault();
    const x = dialog().querySelector('.rsi-form-close-button');
    if (x) x.click();
  }, true);
})();
